import axios from "axios";
import { getCustomerNumber } from '../../../util';

export const errorLogger = async (message, shouldRedirect = true) => {
    try {
        const options = {
            customerNumber: getCustomerNumber(),
            appCustomer: "school-store-ui",
            src: window.location.href,
            occTimestamp: new Date().toString(),
            appEnvironment: navigator.userAgent,
            faultDetails: message
        };

        await axios.post('/apps/store/bummer.mvc', options);

        if(shouldRedirect){
            window.location.href = process.env.REACT_APP_MAINTENANCE_URL;
        }

    } catch (error) {
        console.error("Unable to call bummer.mvc for 404 logging:" + error);

        if (window.location.hostname !== "localhost" && shouldRedirect) {
            window.location.href = process.env.REACT_APP_MAINTENANCE_URL;
        }
    }
}